module.exports = __webpack_public_path__ + "static/media/jptip.479a4133.png";